module.exports = __webpack_public_path__ + "static/img/bal.a0bdeca7.jpg";